import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabIndicatorFn = /* @__PURE__ */ createRecipe('rp-tab-indicator', {}, [])

const tabIndicatorVariantMap = {}

const tabIndicatorVariantKeys = Object.keys(tabIndicatorVariantMap)

export const tabIndicator = /* @__PURE__ */ Object.assign(memo(tabIndicatorFn), {
  __recipe__: true,
  __name__: 'tabIndicator',
  raw: (props) => props,
  variantKeys: tabIndicatorVariantKeys,
  variantMap: tabIndicatorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabIndicatorVariantKeys)
  },
})